var help = {
    fetchGlobalTips: function () {
        if (this.globalTips) {
            return Promise.resolve();
        }

        return new Promise(function (resolve, reject) {
            var systemId = globalpageglobals.cstorefrontsettings.system.id;
            $.ajax({
                url: '/api/supplier-service/suppliers/' + systemId + '/tips',
                method: 'GET',
                accept: 'application/json',
                success: function (globalTips) {
                    help.globalTips = globalTips;
                    resolve();
                },
                error: function () {
                    console.error('Error fetching global tips');
                    reject();
                }
            });
        });
    },
    pos: function (helpLinkId) {
        var pos = $('#validationMessagesDiv').offset();
        pos.top = $('#' + helpLinkId).offset().top;
        return pos;
    },
    getGlobalTip: function (tipName) {
        if (!this.globalTips) {
            return '';
        }
        return this.globalTips.find(function (tip) {
            return tip.name === tipName;
        });
    },
    panelClosed: function () {
        $.disconnect(tipViewPanel, 'close', this, 'panelClosed');
        $(window).unbind('resize');
        dynamic.setClass(this.helpLinkId, 'quoteHelp');
        this.helpLinkId = null;
    },
    windowResized: function () {
        tipViewPanel.windowResized();
    },
    showPanel: function (helpLinkId, content) {
        var previousHelpLinkId = this.helpLinkId;
        if (tipViewPanel.showing) {
            tipViewPanel.close();
        }
        if (previousHelpLinkId === helpLinkId) {
            return;
        }

        $.connect(tipViewPanel, 'close', this, 'panelClosed');
        var tempThis = this;
        $(window).resize(function (e) {
            tempThis.windowResized(e);
        });
        tipViewPanel.open(this.pos(helpLinkId), content);
        this.helpLinkId = helpLinkId;
        dynamic.setClass(helpLinkId, 'quoteHelp on');
    },
    tip: function (object, fieldName, globalName) {
        this.fetchGlobalTips().then(function () {
            var content = help.getHtml(object, fieldName);
            if (content === '') {
                var globalTip = help.getGlobalTip(globalName);
                content = help.getHtml(globalTip, 'content');
            }
            help.showPanel(fieldName, content);
        });
    },
    getHtml: function (object, fieldName) {
        return fieldName in object ? strUnweb(object[fieldName]) : '';
    },
    opTip: function (index) {
        var helpLinkId = 'opTip' + index;

        var coperationsmgr = configureglobals.coperationsmgr;
        var coperations = coperationsmgr.get('operations');
        var coperationdata = coperations[index];
        var cpjcOperation = coperationdata.get('pjcOperation');
        var content = cpjcOperation.getHtml('tipContent');
        if (content == '') {
            var coperation = cpjcOperation.get('operation');
            content = coperation.getHtml('tipContent');
        }

        this.showPanel(helpLinkId, content);
    },
    lfOpTip: function (index) {
        var helpLinkId = 'opTip' + index;
        var coperationdata = configureglobals.coperationdata.get('list');
        var anoperationdata = coperationdata[index];
        var clpjcoperation = anoperationdata.get('lpjcOperation');
        var coperation = clpjcoperation.get('operation');
        var content = clpjcoperation.getHtml('tipContent');
        if (content == '') {
            content = coperation.getHtml('tipContent');
        }
        this.showPanel(helpLinkId, content);
    }
};
